// src/pages/BarcodeScannerPage.tsx
import BarcodeScanner from "../components/BarcodeScanner";

export default function BarcodeScannerPage() {
  return (
    <div className="container py-4">
      <h3 className="mb-3">Quick Product Lookup</h3>
      <BarcodeScanner /> {/* ✅ self-contained lookup */}
    </div>
  );
}
